import {
    SET_LOADING,
    GET_INDICATORS,
    SET_INDICATOR,
    SET_LOADING_ERROR,
    GET_INDICATORS_ERROR,
    SET_INDICATOR_ERROR,
    DELETE_INDICATOR,
    DELETE_INDICATOR_ERROR

} from "./actions";
import {removePlotPoint} from "./DataActions";

export const setLoading = () => {
    return {
        type: SET_LOADING,
    };
};

export const getIndicators = () => async (dispatch) => {
    try {
        setLoading();

        const res = await fetch(process.env.REACT_APP_GET_INDICATOR_LIST_URL);
        const data = await res.json();
        dispatch({
            type: GET_INDICATORS,
            payload: data,
        });
    } catch (err) {
        console.error(err);
        dispatch({
            type: GET_INDICATORS_ERROR,
            payload: err,
        });
    }


};

export const setIndicator = (indciator_id) => async (dispatch) => {
    try {

        dispatch({
            type: SET_INDICATOR,
            payload: indciator_id,
        });
    } catch (err) {
        dispatch({
            type: SET_INDICATOR_ERROR,
            payload: err,
        });
    }

};

export const deleteIndicator = (indciator_id) => async (dispatch) => {

    try {

        dispatch({
            type: DELETE_INDICATOR,
            payload: indciator_id,
        });
    } catch (err) {
        dispatch({
            type: DELETE_INDICATOR_ERROR,
            payload: err,
        });
    }

};


